<template>
  <div>
    <div class="jm-white-container">
      <form>
        <div class="col-lg-10 mx-auto">
          <div class="row">
            <div class="col-12">
              <div class="h5 mb-3">Cinema: {{currentCinemaIndex}}/{{noOfCinemas}}</div>
            </div>
            <div class="col-12" v-for="(item, index) in concessionLevels" :key="index">
              <div class="row">
                <!-- IMAGE DIMENSION -->
                <div class="col-md-4 mb-4">
                  <div class="d-flex align-items-center">
                    <div class="input-container w-100">
                      <input
                        type="text"
                        v-model="item.cl_name"
                        :id="'A'+index"
                        placeholder="Level Name"
                        name="Level Name"
                        v-validate="{required: 'required', regex:/^[a-zA-Z0-9- ]*$/}"
                      />
                      <label :for="'A'+index">Level Name</label>
                    </div>
                    <Tooltip :title="`Add all dimensions of images that would be used in the system`"  />
                  </div>
                  <p v-if="submitted && errors.has('Level Name')" class="error_message">
                    <!-- {{ item.fieldname }} -->
                    {{ errors.first(`${'Level Name'}`)}}
                  </p>
                  <!-- <p class="error_msg">Invalid Entry</p> -->
                </div>
                <div class="col-md-8">
                  <div class="row">
                    <div class="col-md-3">
                      <b-dropdown
                        :text="item.cld_no_of_pos"
                        variant="dropdown-curve-lg bg-theme-light"
                        class="w-100"
                      >
                        <b-dropdown-item
                          v-for="(pos, posKey) in 10"
                          :key="posKey"
                          v-on:click="onSelectHandler('no_of_pos',posKey,index)"
                        >{{posKey}}</b-dropdown-item>
                      </b-dropdown>
                      <p
                        v-if="submitted && item.cld_no_of_pos == 'No of Pos'"
                        class="error_message"
                      >Please Select No of Pos.</p>
                    </div>
                    <div class="col-md-3">
                      <b-dropdown
                        :text="item.cld_no_of_kiosk"
                        variant="dropdown-curve-lg bg-theme-light"
                        class="w-100"
                      >
                        <b-dropdown-item
                          v-for="(kiosk, kioskKey) in 10"
                          :key="kioskKey"
                          v-on:click="onSelectHandler('no_of_kiosk',kioskKey,index)"
                        >{{kioskKey}}</b-dropdown-item>
                      </b-dropdown>
                      <p
                        v-if="submitted && item.cld_no_of_kiosk == 'No of Kiosk'"
                        class="error_message"
                      >Please Select No of Kiosk.</p>
                    </div>
                    <div class="col-md-3">
                      <b-dropdown
                        :text="item.cld_no_of_signages"
                        variant="dropdown-curve-lg bg-theme-light"
                        class="w-100"
                      >
                        <b-dropdown-item
                          v-for="(signages, signagesKey) in 10"
                          :key="signagesKey"
                          v-on:click="onSelectHandler('no_of_signages',signagesKey,index)"
                        >{{signagesKey}}</b-dropdown-item>
                      </b-dropdown>
                      <p
                        v-if="submitted && item.cld_no_of_signages == 'No of signages'"
                        class="error_message"
                      >Please Select No of signages.</p>
                    </div>
                    <div class="col-md-3">
                      <b-dropdown
                        :text="item.cld_no_of_fnb_counters"
                        variant="dropdown-curve-lg bg-theme-light"
                        class="w-100"
                      >
                        <b-dropdown-item
                          v-for="(fnb_counters, fnb_countersKey) in 10"
                          :key="fnb_countersKey"
                          v-on:click="onSelectHandler('no_of_fnb_counters',fnb_countersKey,index)"
                        >{{fnb_countersKey}}</b-dropdown-item>
                      </b-dropdown>
                      <p
                        v-if="submitted && item.cld_no_of_fnb_counters == 'No of fnb counters'"
                        class="error_message"
                      >Please Select No of fnb counters.</p>
                    </div>

                    <!-- <div class="col-md-2 text-right pt-2">
                    <button
                      class="btn-transparent"
                      v-if="index === 0"
                      v-on:click="increaseImageSettingRow()"
                    >
                      <img src="@/assets/img/icons/plus.svg" height="35" width="35" />
                    </button>
                    <button v-else @click="decreaseImageSettingRow(index)" class="btn-transparent">
                      <img src="@/assets/img/icons/minus.svg" height="35" width="35" />
                    </button>
                    </div>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section>
          <div class="text-center">
            <router-link to="cinema-concession-levels" class="btn-outline-blue-lg w-25">Back</router-link>
            <router-link to="database-configuration6" class="btn-outline-blue-lg w-25">Skip</router-link>
            <!-- <router-link to="cinema-configuration" class="btn-blue-lg w-25">Proceed</router-link> -->
            <b-button @click.prevent.stop="onSubmit()" class="btn-blue-lg w-25">Proceed</b-button>
            <!--  -->
            <!-- v-on:click.native="onSubmit()" -->
          </div>
        </section>
      </form>
    </div>
  </div>
</template>

<script>
import SetupService from "@/services/SetupService";
import saveState from "vue-save-state";

export default {
  name: "Concession Levels",
  mixins: [saveState],
  data() {
    return {
      submitted: false,
      concessionLevels: [
        {
          cl_name: "",
          cinema_id: window.localStorage.getItem("CURRENT_CINEMA_ID") || 1,
          cld_no_of_pos: "No of Pos",
          cld_no_of_kiosk: "No of Kiosk",
          cld_no_of_signages: "No of signages",
          cld_no_of_fnb_counters: "No of fnb counters"
        }
      ]
    };
  },
  computed: {
    concessionLevelValue() {
      return this.$store.getters.CONCESSION_LEVELS || 1;
    },
    noOfCinemas() {
      return this.$store.getters.NO_OF_CINEMAS || 1;
    },
    currentCinemaIndex() {
      return this.$store.getters.currentCinemaIndex;
    }
  },
  mounted() {
    // for (var i = 0; i < this.concessionLevelValue; i++) {
    //   this.concessionLevels.push();
    // }
  },
  methods: {
    getSaveStateConfig() {
      return {
        cacheKey: "Concession Levels"
      };
    },
    onSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          let payload = {
            concessionLevels: this.concessionLevels
          };
          SetupService.addCounterLevels(payload)
            .then(result => {
              console.log("result :", result);
              const { data } = result;
              if (data.status) {
                this.$router.push({
                  path: "database-configuration6"
                });
              }
            })
            .catch(err => {
              console.log("err :", err);
            });
        }
      });
    },

    onSelectHandler: function(type, value, index) {
      if (type == "no_of_pos") {
        this.concessionLevels[index].cld_no_of_pos = value;
      } else if (type == "no_of_signages") {
        this.concessionLevels[index].cld_no_of_signages = value;
      } else if (type == "no_of_fnb_counters") {
        this.concessionLevels[index].cld_no_of_fnb_counters = value;
      } else if (type == "no_of_kiosk") {
        this.concessionLevels[index].cld_no_of_kiosk = value;
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/cinemaInstallation/concessionCounters.vue